import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';

interface ICheckboxFieldProps {
  label: string;
  defaultValue?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isChecked?: boolean;
  fontSize?: string;
  paddingTop?: string;
}
const CheckBoxComponent = ({
  label,
  defaultValue,
  onChange,
  isChecked,
  fontSize,
  paddingTop
}: ICheckboxFieldProps): JSX.Element => {
  return (
    <FormControlLabel
      control={
        <Checkbox checked={isChecked ?? defaultValue} onChange={onChange} />
      }
      label={
        <Typography
          style={{
            fontFamily: 'Be Vietnam Pro',
            fontWeight: 500,
            fontSize: fontSize ?? '11px',
            color: '#44474E',
            paddingTop
          }}
        >
          {label}
        </Typography>
      }
    />
  );
};

export default CheckBoxComponent;
